import React from 'react'
import styled from 'styled-components'
import { Box, Icon, muiBankTheme, useMediaSize } from '@ally/metronome-ui'
import useMboxCall from '@ally/use-mbox-call'
import { getAdobeIcon } from '../../adobeIcons'
import { AdobeResponse, MboxContent, MboxResponseObj } from '../../types'
import { MboxTargetLink } from './MboxTargetLink'
import { verifyContent } from '../../utils'

const Wrapper = styled(Box)`
  ${({ theme: { colors } }): string =>
    `
    border-top: 1px solid ${colors['slate-2']};
    display: flex;
  `};
`

const StyledBox = styled(Box)`
  ${({ theme: { media } }): string =>
    `
  ${media.down('sm')} {
    margin-right: 32px;
  }
  `};
`

export const ContentWell: React.FC<{
  wellData: AdobeResponse<MboxContent>
  mboxName: string
}> = ({ wellData, mboxName }) => {
  const wellDataSetJson = wellData.filter(
    item => item.action === 'setJson',
  )[0] as MboxResponseObj<MboxContent>
  const {
    ctaHref,
    ctaLabel,
    ctaNewTab,
    description,
    iconColor,
    iconName,
    _id,
  } = wellDataSetJson.content[0]

  const adobeIcon = getAdobeIcon(iconName)
  return (
    <Box
      display="flex"
      data-track-mbox={mboxName}
      data-track-offerid={_id || null}
      alignItems="center"
    >
      <Icon
        icon={adobeIcon}
        size="xl"
        fill={
          muiBankTheme.colors[
            iconColor || 'plum'
          ] as keyof typeof muiBankTheme.colors
        }
        ariaHidden
        mr="xs"
      />
      <StyledBox flex="1">
        <Box display="inline" mr="xs">
          {description}
        </Box>
        {ctaHref && (
          <MboxTargetLink to={ctaHref} text={ctaLabel} ctaNewTab={ctaNewTab} />
        )}
      </StyledBox>
    </Box>
  )
}

interface MboxProps {
  name: string
}
export const AccountCardMbox: React.FC<MboxProps> = ({ name }) => {
  const mboxInfo = useMboxCall(name, []).mboxData
  const verify = (): boolean => {
    try {
      return verifyContent(mboxInfo)
    } catch {
      return false
    }
  }
  const isMdDown = useMediaSize('MdDown')

  return (
    <>
      {verify() ? (
        <Wrapper pb="xs" pt="sm" pl={isMdDown ? 'sm' : 'xs'}>
          <ContentWell wellData={mboxInfo} mboxName={name} />
        </Wrapper>
      ) : null}
    </>
  )
}
